import { observer } from "mobx-react";
import { useEstimateStructure, useEstimateEditorSettings } from "@tools";
import { Grid } from "@material-ui/core";
import { TotalsFactory } from "./components";
import {
  TotalCompanyCost,
  TotalCost,
  TotalProfit,
  TotalProfitability
} from "./totalsTypes";

export const CompactTotals = observer(() => {
  const { settings }  = useEstimateStructure();
  
  const { isSellerOrClient, useProfitability } = useEstimateEditorSettings();
  
  const { visibleTotals } = settings;
  
  const totals = visibleTotals.filter(({noDev}) => !noDev || isSellerOrClient);
  
  return (
    <Grid
      container
      className="w-max"
      justifyContent="flex-end"
      wrap="nowrap"
    >
      {
        useProfitability
          ? <>
            <TotalCompanyCost compact />
            <TotalCost compact isRevenue />
            <TotalProfit compact />
            <TotalProfitability compact />
          </>
          : totals.map(({ name }) => (
            <TotalsFactory
              key={name}
              name={name}
              compact
            />
          ))
      }
    </Grid>
  )
});